<template>
  <div class="pricing-detail-wrap">
    <div class="price-card-wrap">
      <PricingCard
        v-for="(item, index) in data.pricingtype"
        :key="index"
        :item="item"
        :index="index"
      />
    </div>
    <div class="custom-button">
      <router-link :to="signUpLink">
        Sign Up Now
      </router-link>
    </div>
    <Faq :data="data.faq" :extraClass="['grey-bg', 'no-padding-top']" />
  </div>
</template>

<script>
import { AthleteData } from "./data";
import PricingCard from "./price-card";
import Faq from "@/pageComponents/globalUi/faq";

export default {
  name: "PricngDetails",
  components: {
    PricingCard,
    Faq
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    signUpLink: {
      type: String,
      default: "/register"
    }
  },
  data() {
    return {
      AthleteData
    };
  }
};
</script>

<style lang="scss">
.pricing-detail-wrap {
  padding: 50px 0;
  .price-card-wrap {
    display: flex;
    justify-content: center;
    .price-card {
      margin-right: 50px;
      max-width: 400px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .custom-button {
    display: flex;
    justify-content: center;
    margin: 60px 0 120px;
  }
}
@media only screen and (max-width: 767px) {
  .pricing-detail-wrap {
    padding: 35px 0;
    .price-card-wrap {
      flex-direction: column;
      .price-card {
        margin: 0 auto;
        &:last-child {
          margin: 30px auto 0;
        }
      }
    }
  }
}
</style>
